import React, { useEffect, useState } from 'react'
import { deleteItem, loadLanguages, } from 'cms/utils/Network';
import { useParams } from 'react-router-dom';
import { isAdmin, sortLanguages, userAvatar } from 'cms/utils';
import NamesWidget from 'cms/components/widgets/NamesWidget';
import {
  stubGeneralTitle,
  stubGeneralDescription,
  stubRefereeTitle,
  stubRefereeDescription,
  stubGuestTitle,
  stubGuestDescription,
  stubTop10Title,
  stubTop10Description,
  stubTop30Title,
  stubTop30Description,
} from 'cms/utils/courseHistoryNameStubs';
import Gallery from '../Gallery';
import Navbar from 'cms/components/Navbar';
import Mainmenu from 'cms/components/Mainmenu';
import Footer from 'cms/components/Footer';
import SelectCourses from 'cms/components/SelectCourses';
import SelectPublished from 'cms/components/select/SelectPublished';
import { ApiHttpService } from 'cms/utils/http/api';
import SelectCourseParticipantModal from 'cms/components/contest/SelectCourseParticipantModal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import Modal from 'react-modal';
import HistoryGalleryForm from 'cms/components/forms/HistoryGalleryForm';
import EpisodeGalleryCardsWidget from 'cms/pages/contest/widgets/EpisodeGalleryCardsWidget';
import SelectCourseRefereeModal from 'cms/components/contest/SelectCourseRefereeModal';
import TabsWidget from 'cms/pages/shared/dashboard/widgets/TabsWidget';


export default function CourseHistoryDetails() {

  const [course_history, setCourseHistory] = useState(null);
  const [course_history_talents, setCourseHistoryTalents] = useState(null);
  const [course_history_topten_talents, setCourseHistoryTopTenTalents] = useState(null);
  const [course_history_topfinal_talents, setCourseHistoryTopFinalTalents] = useState(null);
  const [course_history_champions, setCourseHistoryChampions] = useState(null);

  const [referees, setReferees] = useState(null);
  const [guest_referees, setGuestReferees] = useState(null);
  const [performers, setPerformers] = useState(null);
  
  const [names, setNames] = useState(null);
  const [published, setPublished] = useState(null);
  const [course, setCourse] = useState(null);
  const [languages, setLanguages] = useState(null);
  const [gallery_modal_is_open, setGalleryModalIsOpen] = useState(false);
  const [courseparticipant_modal_is_open, setCourseParticipantModalIsOpen] = useState(false);
  const [referee_modal_is_open, setRefereeModalIsOpen] = useState(false);
  const [exlclude_ids, setExcludeIds] = useState([]);
  const [is_guest, setIsGuest] = useState(false);
  const [is_performer, setIsPerformer] = useState(false);
  
  const [top_ten_mode, setTopTenMode] = useState(false);

  const [show_delete, setShowDelete] = useState(false);

  const [historyGalleryModalIsOpen, setAddHistoryGalleryModalIsOpen] = useState(false);
  const [courseHistoryGalleries, setCourseHistoryGalleries] = useState(false);


  const params = useParams()
  var id = params.id

  const [course_history_image, setCourseHistoryImage] = useState(null);


  const [error, setError] = useState(null);
  const [done, setDone] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cacheRefreshing, setCacheRefreshing] = useState(false);
  const [pageloading, setPageLoading] = useState(false);
  const [sectionTab, setSectionTab] = useState('general');
  const [top30CopyEditOpen, setTop30CopyEditOpen] = useState(false);

  const sectionTabs = [
    { key: 'general', label: 'General', icon: 'fa-info-circle' },
    { key: 'referees', label: 'Referees', icon: 'fa-gavel' },
    { key: 'performers', label: 'Hosts', icon: 'fa-microphone' },
    { key: 'finalists_champions', label: 'Finalists', icon: 'fa-trophy' },
    { key: 'top30', label: 'Top 30', icon: 'fa-users' },
    { key: 'episodes', label: 'Episodes', icon: 'fa-film' },
  ];

  useEffect(() => {
    setPageLoading(true)
    loadLanguages().then(languages => {

      //languages=languages.filter(x=> x.language !==16)
      setLanguages(sortLanguages(languages));
      setPageLoading(false)
    });


    if (id) {
      setPageLoading(true)
      ApiHttpService.loadCourseHistory(id).then(courseHistory => {
        setCourseHistory(courseHistory)
        setNames(courseHistory.names)
        setCourse(courseHistory.course.id)
        setPublished(courseHistory.published)
        setCourseHistoryImage(courseHistory.image)

        _getReferees()
        _getCourseHistoryTalents()
        _getTopTen()
        _getFinalists()
        _getChampions()
        _getCourseHistoryGalleries()
      })
    }
  }, [])


  const _getReferees = () => {
    ApiHttpService.loadCourseHistoryReferees(id).then(data => {
      if (data.results) {
        setReferees(data.results.filter(item => (!item.is_guest && !item.is_performer)))
        setGuestReferees(data.results.filter(item => item.is_guest))
        setPerformers(data.results.filter(item => item.is_performer))
      }
    })
  }

  const _getCourseHistoryTalents = () => {
    ApiHttpService.loadCourseHistoryTalents(id).then(data => {
      if (data.results)
        setCourseHistoryTalents(data.results)
    })
  }

  const _getCourseHistoryGalleries = () => {
    ApiHttpService.loadCourseHistoryGalleries(id).then(data => {
      if (data.results)
        setCourseHistoryGalleries(data.results)
    })
  }

  const _getTopTen = () => {
    ApiHttpService.loadCourseHistoryTalents(id, 1).then(data => {
      if (data.results)
        setCourseHistoryTopTenTalents(data.results)
    })
  }

  const _getFinalists = () => {
    ApiHttpService.loadCourseHistoryFinalTalents(id).then(data => {
      if (data.results)
        setCourseHistoryTopFinalTalents(data.results)
    })
  }

  const _getChampions = () => {
    ApiHttpService.loadCourseHistoryChampions(id).then(data => {
      if (data.results)
        setCourseHistoryChampions(data.results)
    })
  }




  const saveChanges = () => {

    setError(null);
    setLoading(true);
    setDone(null)

    if (!names || names[0].name.length < 3) {
      setError('Please Enter Name');
      setLoading(false);
      return;
    }

    if (!course) {
      setError('Please Select Contest');
      setLoading(false);
      return;
    }


    var body = {
      course: course,
      names: names,
      published: published,
      image: course_history_image,
    }



    if (id) body["id"] = id


    ApiHttpService.saveCourseHistory(body).then(function (data) {
      setLoading(false);
      setDone("Changes saved successfully")
      if (data.image) setCourseHistoryImage(data.image);
    });
  }

  const refreshPublicCache = () => {
    if (!id) return;
    setCacheRefreshing(true);
    setError(null);
    setDone(null);
    ApiHttpService.refreshCourseHistoryPublicCache(id).then((data) => {
      setCacheRefreshing(false);
      if (data && data.ok) {
        setDone(data.message || "Public page cache refreshed");
      } else {
        setError((data && data.message) || "Could not refresh cache");
      }
    }).catch(() => {
      setCacheRefreshing(false);
      setError("Could not refresh cache");
    });
  }

  const setSelectedImageGallery = (gallery_item) => {
    setCourseHistoryImage(gallery_item?.image)
  }


  const openGallery = () => {

    setGalleryModalIsOpen(true)

  }

  const closeGallery = () => {
    setGalleryModalIsOpen(false)
  }

  const closeCourseParticipantModal = () => {
    setCourseParticipantModalIsOpen(false)
  }


  const addSelectedId = (courseparticipant) => {
    var body = {
      coursehistory: id,
      courseparticipant: courseparticipant,
    }


    body['topten'] = 0;
    if (top_ten_mode === 1) {
      body['topten'] = 1;
    } else if (top_ten_mode === 2) {
      body['final'] = 1;
    } else if (top_ten_mode === 3) {
      body['champion'] = 1;
    }

    setLoading(true)

    ApiHttpService.saveCourseHistoryTalent(body).then(data => {
      if (top_ten_mode == 1)
        _getTopTen()
      else if (top_ten_mode == 2) {
        _getFinalists()
      } else if (top_ten_mode == 3) {
        _getChampions()
      }
      else {
        _getCourseHistoryTalents()
      }

      setLoading(false)
    })

  }


  const addRefereeToHistory = (referee) => {
    var body = {
      coursehistory: course_history.id,
      is_guest: is_guest,
      is_performer: is_performer,
      referee: referee,
    }

    console.log(body)

    setLoading(true)

    ApiHttpService.saveCourseHistoryReferee(body).then(data => {
      _getReferees()
      setLoading(false)
    })

  }

  const _delete = (id, type) => {

    if (window.confirm('Are you sure you wish to delete this item?')) {
      switch (type) {
        case "coursehistoryreferee":
          deleteItem(`api/coursehistoryreferee`, id).then((res) => {
            setReferees(referees.filter(item => item.id !== id))
            setPerformers(performers.filter(item => item.id !== id))
            setGuestReferees(guest_referees.filter(item => item.id !== id))
          })
          break;
        case "coursehistorytalent":
          deleteItem(`api/coursehistorytalent`, id).then((res) => {

            if (top_ten_mode === 0 || top_ten_mode === 1) {
              setCourseHistoryTalents(course_history_talents.filter(item => item.id !== id))
            }
            else if (top_ten_mode === 2) {
              setCourseHistoryTopFinalTalents(course_history_topfinal_talents.filter(item => item.id !== id))
            }
            else if (top_ten_mode === 3) {
              setCourseHistoryChampions(course_history_champions.filter(item => item.id !== id))
            }
          })
          break;
        default: return
      }
    }


  }

  const onRefereesDragEnd = result => {
    const { destination, source, draggableId } = result;

    if (!destination) return;
    if (
      destination.draggableId === source.draggableId &&
      destination.index === source.index
    )
      return;

    var referee = referees.find(x => x.id == draggableId)
    var temp = referees;

    temp.splice(source.index, 1)
    temp.splice(destination.index, 0, referee)

    var ids = [];
    temp.forEach(child => {
      ids.push(child.id)
    })

    ApiHttpService.saveSortOrder(`api/coursehistoryreferee/setsortorder/`, ids).then(data => {
      console.log(data)
    })

    setReferees(temp)
  }

  const onPerformerDragEnd = result => {
    const { destination, source, draggableId } = result;

    if (!destination) return;
    if (
      destination.draggableId === source.draggableId &&
      destination.index === source.index
    )
      return;

    var referee = performers.find(x => x.id == draggableId)
    var temp = performers;

    temp.splice(source.index, 1)
    temp.splice(destination.index, 0, referee)

    var ids = [];
    temp.forEach(child => {
      ids.push(child.id)
    })

    ApiHttpService.saveSortOrder(`api/coursehistoryreferee/setsortorder/`, ids).then(data => {
      console.log(data)
    })

    setPerformers(temp)
  }

  

  const onGuestRefereesDragEnd = result => {
    const { destination, source, draggableId } = result;

    if (!destination) return;
    if (
      destination.draggableId === source.draggableId &&
      destination.index === source.index
    )
      return;

    var referee = guest_referees.find(x => x.id == draggableId)
    var temp = guest_referees;

    temp.splice(source.index, 1)
    temp.splice(destination.index, 0, referee)

    var ids = [];
    temp.forEach(child => {
      ids.push(child.id)
    })

    ApiHttpService.saveSortOrder(`api/coursehistoryreferee/setsortorder/`, ids).then(data => {
      console.log(data)
    })

    setGuestReferees(temp)
  }

  const onTalentDragEnd = result => {
    const { destination, source, draggableId } = result;

    if (!destination) return;
    if (
      destination.draggableId === source.draggableId &&
      destination.index === source.index
    )
      return;

    var talent = course_history_talents.find(x => x.id == draggableId)
    var temp = course_history_talents;

    temp.splice(source.index, 1)
    temp.splice(destination.index, 0, talent)

    var ids = [];
    temp.forEach(child => {
      ids.push(child.id)
    })

    ApiHttpService.saveSortOrder(`api/coursehistorytalent/setsortorder/`, ids).then(data => {
      console.log(data)
    })

    setCourseHistoryTalents(temp)
  }

  const onTopTenTalentDragEnd = result => {
    const { destination, source, draggableId } = result;

    if (!destination) return;
    if (
      destination.draggableId === source.draggableId &&
      destination.index === source.index
    )
      return;

    var talent = course_history_topten_talents.find(x => x.id == draggableId)
    var temp = course_history_topten_talents;

    temp.splice(source.index, 1)
    temp.splice(destination.index, 0, talent)

    var ids = [];
    temp.forEach(child => {
      ids.push(child.id)
    })

    ApiHttpService.saveSortOrder(`api/coursehistorytalent/setsortorder/`, ids).then(data => {
      console.log(data)
    })

    setCourseHistoryTalents(temp)
  }


  const onTopFinalTalentDragEnd = result => {
    const { destination, source, draggableId } = result;

    if (!destination) return;
    if (
      destination.draggableId === source.draggableId &&
      destination.index === source.index
    )
      return;

    var talent = course_history_topfinal_talents.find(x => x.id == draggableId)
    var temp = course_history_topfinal_talents;

    temp.splice(source.index, 1)
    temp.splice(destination.index, 0, talent)

    var ids = [];
    temp.forEach(child => {
      ids.push(child.id)
    })

    ApiHttpService.saveSortOrder(`api/coursehistorytalent/setsortorder/`, ids).then(data => {
      console.log(data)
    })

    setCourseHistoryTopFinalTalents(temp)
  }

  const onChampionsDragEnd = result => {
    const { destination, source, draggableId } = result;

    if (!destination) return;
    if (
      destination.draggableId === source.draggableId &&
      destination.index === source.index
    )
      return;

    var talent = course_history_champions.find(x => x.id == draggableId)
    var temp = course_history_champions;

    temp.splice(source.index, 1)
    temp.splice(destination.index, 0, talent)

    var ids = [];
    temp.forEach(child => {
      ids.push(child.id)
    })

    ApiHttpService.saveSortOrder(`api/coursehistorytalent/setsortorder/`, ids).then(data => {
      console.log(data)
    })

    setCourseHistoryChampions(temp)
  }




  const closeHistoryGalleryModal = () => {
    setAddHistoryGalleryModalIsOpen(false)
  }


  return (
    <div className="wrapper">
      <Navbar />
      <Mainmenu />
      <Gallery
        setSelectedGalleryItem={setSelectedImageGallery}
        isOpen={gallery_modal_is_open}
        key={"gmo" + gallery_modal_is_open}
        closeGallery={() => {
          closeGallery();
        }}
      />
      {courseparticipant_modal_is_open &&
        <SelectCourseParticipantModal
          course={course}
          isOpen={courseparticipant_modal_is_open}
          key={"cpm" + courseparticipant_modal_is_open}
          excludeIds={exlclude_ids}
          setSelectedItem={(item) => {
            if (item) {
              addSelectedId(item.id)
            }
            setCourseParticipantModalIsOpen(false)
          }}
          onClose={() => {
            closeCourseParticipantModal();
          }}
        />
      }

      {referee_modal_is_open &&
        <SelectCourseRefereeModal
          course={course}
          excludeIds={exlclude_ids}
          isOpen={referee_modal_is_open}
          key={"cpm" + referee_modal_is_open}
          setSelectedItem={(item) => {
            if (item) {
              addRefereeToHistory(item.id)
            }
            setRefereeModalIsOpen(false)
          }}
          onClose={() => {
            setRefereeModalIsOpen(false)
          }}
        />
      }


      {historyGalleryModalIsOpen &&
        <Modal
          closeTimeoutMS={500}
          isOpen={historyGalleryModalIsOpen}
          onRequestClose={closeHistoryGalleryModal}
          className="Modal no-scrollbar"
          overlayClassName="Overlay"
        >
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" onClick={closeHistoryGalleryModal}>
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 className="modal-title">Add Episode to Gallery</h4>
            </div>
            <div className="modal-body text-center">
              <HistoryGalleryForm course_history={course_history && course_history.id} callback={() => { setAddHistoryGalleryModalIsOpen(false); _getCourseHistoryGalleries() }} />
            </div>

          </div>
        </Modal>
      }

      <div className="content-wrapper">
        <section className="content-header">
          <ol className="breadcrumb">
            <li>
              <a href="/cms/dashboard">
                <i className="fa fa-dashboard"></i> Home
              </a>
            </li>
            <li>
              <a href="/cms/coursehistories">Histories</a>
            </li>
            <li className="active">View</li>
          </ol>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <TabsWidget
                tabs={sectionTabs}
                activeTab={sectionTab}
                onTabChange={setSectionTab}
                className="cms-page-tabs course-history-section-tabs"
              />
              <div className="cms-page-tab-content">
              {sectionTab === 'general' && (
              <>
                <div>
                  <div className=" ">
                    {pageloading && (
                      <>
                        <div className="overlay">
                          <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                        </div>
                      </>
                    )}

                    <form className="form-horizontal">
                      <div>
                        <div className="col-md-7">
                          <NamesWidget
                            languages={languages}
                            names={names}
                            onNamesChange={setNames}
                            titleField="name"
                            descriptionField="description"
                            stubTitleEntry={stubGeneralTitle}
                            stubDescriptionEntry={stubGeneralDescription}
                            allowNewEntryFromDescription={!id}
                          />
                        </div>
                        <div className="col-md-5 pt-10">
                          <div className="form-group mx-0">
                            <img
                              className="img upload-img mb-5"
                              onClick={openGallery}
                              alt=""
                              src={
                                course_history_image
                                  ? course_history_image
                                  : "/assets/images/default.png"
                              }
                            />
                          </div>
                          <div className="form-group mx-0">
                            <SelectCourses
                              key={course}
                              value={course}
                              callback={(value) => { setCourse(value) }} />
                          </div>
                          <div className="form-group mx-0">
                            <SelectPublished
                              key={published}
                              value={published}
                              callback={(value) => { setPublished(value) }} />
                          </div>
                        </div>




                      </div>
                    </form>
                  </div>
                </div>

                <div className="clearfix mt-15 ">
                  {isAdmin() &&
                    <button
                      type="button"
                      onClick={saveChanges}
                      disabled={loading}
                      className="btn btn-cm pull-right"
                    >
                      Save Changes
                    </button>
                  }

                  {isAdmin() && id &&
                    <button
                      type="button"
                      onClick={refreshPublicCache}
                      disabled={cacheRefreshing}
                      className="btn btn-cm pull-right ml-10 mx-2"
                      title="Rebuild the cached public contest history JSON (used by the site and slug URL). Use after changing referees, talents, or episodes without editing General."
                    >
                      {/* {cacheRefreshing ? "Refreshing…" : "Refresh public cache"} */}
                      <i className="fa fa-refresh"></i>
                    </button>
                  }

                  {id && (
                    <a href="/cms/coursehistories" className="btn btn-cm pull-right ml-10">
                      Cancel
                    </a>
                  )}

                  <div className="clearfix"></div>

                  {error && (
                    <>
                      <div className="alert alert-danger mt-5">{error}</div>
                    </>
                  )}

                  {done &&
                    <div className="alert alert-success  mt-5">
                      {done}
                    </div>
                  }

                  {loading && (
                    <>
                      <div className="alert alert-info mt-5">please wait...</div>
                    </>
                  )}
                </div>
              </>
              )}
              {sectionTab === 'referees' && (
              <div className={`course-history-referees-tab${show_delete ? ' course-history-referees-tab--delete-mode' : ''}`}>
                  <div className="course-history-referee-toolbar clearfix">
                    <a href="#open_guest_referee" onClick={(e) => {
                      e.preventDefault();
                      var ids = guest_referees.map(item => item?.referee.id)
                      ids = [...ids, ...referees.map(item => item?.referee.id)]
                      setExcludeIds(ids)
                      setIsGuest(true)
                      setIsPerformer(false)
                      setRefereeModalIsOpen(true)
                    }} title="Add guest referee" className="btn btn-cm pull-right ml-10 "><i className="fa fa-user-plus"></i></a>
                    <a href="#open_referee" onClick={(e) => {
                      e.preventDefault();
                      var ids = referees.map(item => item?.referee.id)
                      setExcludeIds(ids)
                      setIsGuest(false)
                      setIsPerformer(false)
                      setRefereeModalIsOpen(true)
                    }} title="Add referee" className="btn btn-cm pull-right ml-10 "><i className="fa fa-plus"></i></a>
                    <a href="#show_delete" onClick={(e) => { e.preventDefault(); setShowDelete(!show_delete) }} className="btn btn-cm pull-right ml-10 "><i className="fa fa-trash"></i></a>
                  </div>

                  <div className="course-history-referee-panel">
                    <div className="course-history-referee-panel__head">
                      <span className="course-history-referee-panel__title">Referees</span>
                    </div>
                    <div className="course-history-referee-panel__body">
                      <NamesWidget
                        languages={languages}
                        names={names}
                        showDescription={false}
                        onNamesChange={setNames}
                        titleField="referee_title"
                        descriptionField="referee_description"
                        stubTitleEntry={stubRefereeTitle}
                        stubDescriptionEntry={stubRefereeDescription}
                        allowNewEntryFromDescription={!id}
                      />
                      <DragDropContext onDragEnd={onRefereesDragEnd}>
                        <Droppable droppableId="referee_droppable">
                          {(drop_provided, snapshot) => (
                            <div
                              className={`course-history-referee-avatars${snapshot.isDraggingOver ? ' is-dragging-over' : ''}`}
                              ref={drop_provided.innerRef}
                              {...drop_provided.droppableProps}
                            >
                              {referees?.map((item, index) => (
                                <Draggable
                                  key={`ref${item.id}`}
                                  draggableId={`${item.id}`}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      ref={provided.innerRef}
                                      className="course-history-referee-avatar-item"
                                    >
                                      <a
                                        href={`/cms/jury/${item.referee.user?.profile?.id}`}
                                        className="course-history-referee-avatar-item__link"
                                      >
                                        <img src={userAvatar(item.referee.user?.profile)} alt="" />
                                      </a>
                                      {show_delete && (
                                        <button
                                          type="button"
                                          className="course-history-referee-avatar-item__delete"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            _delete(item.id, 'coursehistoryreferee');
                                          }}
                                          aria-label="Remove referee"
                                        >
                                          <i className="fa fa-trash" />
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {drop_provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>

                  <div className="course-history-referee-panel">
                    <div className="course-history-referee-panel__head">
                      <span className="course-history-referee-panel__title">Guest referees</span>
                    </div>
                    <div className="course-history-referee-panel__body">
                      <NamesWidget
                        languages={languages}
                        names={names}
                        showDescription={false}
                        onNamesChange={setNames}
                        titleField="guest_referee_title"
                        descriptionField="guest_referee_description"
                        stubTitleEntry={stubGuestTitle}
                        stubDescriptionEntry={stubGuestDescription}
                        allowNewEntryFromDescription={!id}
                      />
                      <DragDropContext onDragEnd={onGuestRefereesDragEnd}>
                        <Droppable droppableId="guest_referee_droppable">
                          {(drop_provided, snapshot) => (
                            <div
                              className={`course-history-referee-avatars${snapshot.isDraggingOver ? ' is-dragging-over' : ''}`}
                              ref={drop_provided.innerRef}
                              {...drop_provided.droppableProps}
                            >
                              {guest_referees?.map((item, index) => (
                                <Draggable
                                  key={`guest_ref${item.id}`}
                                  draggableId={`${item.id}`}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      ref={provided.innerRef}
                                      className="course-history-referee-avatar-item"
                                    >
                                      <a
                                        href={`/cms/jury/${item.referee.user?.profile?.id}`}
                                        className="course-history-referee-avatar-item__link"
                                      >
                                        <img src={userAvatar(item.referee.user?.profile)} alt="" />
                                      </a>
                                      {show_delete && (
                                        <button
                                          type="button"
                                          className="course-history-referee-avatar-item__delete"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            _delete(item.id, 'coursehistoryreferee');
                                          }}
                                          aria-label="Remove guest referee"
                                        >
                                          <i className="fa fa-trash" />
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {drop_provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>
              </div>
              )}
              {sectionTab === 'performers' && (
              <div>
                  <div className="clearfix mb-10">
                    <a href="#open" onClick={(e) => {
                      e.preventDefault();
                      var ids = performers.map(item => item?.referee.id)
                      ids = [...ids, ...referees.map(item => item?.referee.id), ...guest_referees.map(item => item?.referee.id)]
                      setExcludeIds(ids)
                      setIsGuest(false)
                      setIsPerformer(true)
                      setRefereeModalIsOpen(true)
                    }} title="Add New" className="btn btn-cm pull-right ml-10 "><i className="fa fa-plus"></i></a>
                    <a href="#show_delete" onClick={(e) => { e.preventDefault(); setShowDelete(!show_delete) }} className="btn btn-cm pull-right ml-10 "><i className="fa fa-trash"></i></a>
                  </div>
                  <div className="col-md-12 ">
                    <div className="row">
                      
                      <div className="col-md-12">
                        <DragDropContext
                          onDragEnd={onPerformerDragEnd}
                        >
                          <Droppable droppableId={'performer_droppable'}>
                            {(drop_provided, snapshot) => (
                              <div className="flex-space-evenly"
                                ref={drop_provided.innerRef}
                                style={{ backgroundColor: snapshot.isDraggingOver ? 'rgba(60, 141, 188, 0.12)' : 'transparent' }}
                                {...drop_provided.droppableProps}>

                                {performers?.map((item, index) => (
                                  <Draggable
                                    key={`performer_${item.id}`}
                                    draggableId={`${item.id}`}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <div
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        ref={provided.innerRef}
                                        className="mb-5 ">
                                        <a href={`/cms/jury/${item.referee.user?.profile?.id}`}>
                                          <img src={userAvatar(item.referee.user?.profile)} alt="" className="img-circle img-fluid mb-5" />
                                        </a>
                                        {show_delete && (
                                          <a href="#delete" onClick={(e) => { e.preventDefault(); _delete(item.id, "coursehistoryreferee") }} className="btn btn-cm btn-sm pull-right mb-10 ">
                                            <i className="fa fa-trash"></i>
                                          </a>
                                        )}
                                      </div>
                                    )}
                                  </Draggable>
                                )
                                )}
                                {drop_provided.placeholder}
                              </div>

                            )}
                          </Droppable>
                          <div className="clear"></div>
                        </DragDropContext>
                      </div>
                    </div>
                  </div>
              </div>
              )}
              {sectionTab === 'finalists_champions' && (
              <div className={`course-history-referees-tab course-history-results-tab${show_delete ? ' course-history-referees-tab--delete-mode' : ''}`}>
                  <div className="course-history-referee-toolbar clearfix">
                    <a href="#show_delete_results" onClick={(e) => { e.preventDefault(); setShowDelete(!show_delete) }} className="btn btn-cm pull-right ml-10 "><i className="fa fa-trash"></i></a>
                  </div>

                  <div className="course-history-referee-panel">
                    <div className="course-history-referee-panel__head course-history-referee-panel__head--with-actions">
                      <span className="course-history-referee-panel__title">Champions</span>
                      <a href="#add_champion" onClick={(e) => {
                        e.preventDefault();
                        var ids = course_history_champions.map(item => item.courseparticipant.id)
                        setExcludeIds(ids)
                        setTopTenMode(3)
                        setCourseParticipantModalIsOpen(true)
                      }} title="Add champion" className="btn btn-cm btn-sm"><i className="fa fa-plus"></i></a>
                    </div>
                    <div className="course-history-referee-panel__body">
                      <DragDropContext onDragEnd={onChampionsDragEnd}>
                        <Droppable droppableId="champions_droppable">
                          {(drop_provided, snapshot) => (
                            <div
                              className={`course-history-referee-avatars course-history-referee-avatars--solo${snapshot.isDraggingOver ? ' is-dragging-over' : ''}`}
                              ref={drop_provided.innerRef}
                              {...drop_provided.droppableProps}
                            >
                              {course_history_champions?.map((item, i) => (
                                <Draggable key={`champions${item.id}`} draggableId={`${item.id}`} index={i}>
                                  {(provided) => (
                                    <div
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      ref={provided.innerRef}
                                      className="course-history-referee-avatar-item"
                                    >
                                      <a
                                        href={`/cms/usertalent/${item.courseparticipant.usertalent.user?.profile?.id}`}
                                        className="course-history-referee-avatar-item__link"
                                      >
                                        <img src={userAvatar(item.courseparticipant.usertalent.user?.profile)} alt="" />
                                      </a>
                                      {show_delete && (
                                        <button
                                          type="button"
                                          className="course-history-referee-avatar-item__delete"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setTopTenMode(3);
                                            _delete(item.id, 'coursehistorytalent');
                                          }}
                                          aria-label="Remove champion"
                                        >
                                          <i className="fa fa-trash" />
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {drop_provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>

                  <div className="course-history-referee-panel">
                    <div className="course-history-referee-panel__head course-history-referee-panel__head--with-actions">
                      <span className="course-history-referee-panel__title">Finalists</span>
                      <a href="#add_finalist" onClick={(e) => {
                        e.preventDefault();
                        var ids = course_history_topfinal_talents.map(item => item.courseparticipant.id)
                        setExcludeIds(ids)
                        setTopTenMode(2)
                        setCourseParticipantModalIsOpen(true)
                      }} title="Add finalist" className="btn btn-cm btn-sm"><i className="fa fa-plus"></i></a>
                    </div>
                    <div className="course-history-referee-panel__body">
                      <DragDropContext onDragEnd={onTopFinalTalentDragEnd}>
                        <Droppable droppableId="topfinal_droppable">
                          {(drop_provided, snapshot) => (
                            <div
                              className={`course-history-referee-avatars course-history-referee-avatars--solo${snapshot.isDraggingOver ? ' is-dragging-over' : ''}`}
                              ref={drop_provided.innerRef}
                              {...drop_provided.droppableProps}
                            >
                              {course_history_topfinal_talents?.map((item, i) => (
                                <Draggable key={`topfinal${item.id}`} draggableId={`${item.id}`} index={i}>
                                  {(provided) => (
                                    <div
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      ref={provided.innerRef}
                                      className="course-history-referee-avatar-item"
                                    >
                                      <a
                                        href={`/cms/usertalent/${item.courseparticipant.usertalent.user?.profile?.id}`}
                                        className="course-history-referee-avatar-item__link"
                                      >
                                        <img src={userAvatar(item.courseparticipant.usertalent.user?.profile)} alt="" />
                                      </a>
                                      {show_delete && (
                                        <button
                                          type="button"
                                          className="course-history-referee-avatar-item__delete"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setTopTenMode(2);
                                            _delete(item.id, 'coursehistorytalent');
                                          }}
                                          aria-label="Remove finalist"
                                        >
                                          <i className="fa fa-trash" />
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {drop_provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>

                  <div className="course-history-referee-panel">
                    <div className="course-history-referee-panel__head course-history-referee-panel__head--with-actions">
                      <span className="course-history-referee-panel__title">Top 10</span>
                      <a href="#add_top10" onClick={(e) => {
                        e.preventDefault();
                        var ids = course_history_topten_talents.map(item => item.courseparticipant.id)
                        setExcludeIds(ids)
                        setTopTenMode(1)
                        setCourseParticipantModalIsOpen(true)
                      }} title="Add to Top 10" className="btn btn-cm btn-sm"><i className="fa fa-plus"></i></a>
                    </div>
                    <div className="course-history-referee-panel__body">
                      <NamesWidget
                        languages={languages}
                        names={names}
                        showDescription={false}
                        onNamesChange={setNames}
                        titleField="top10_title"
                        descriptionField="top10_description"
                        stubTitleEntry={stubTop10Title}
                        stubDescriptionEntry={stubTop10Description}
                        allowNewEntryFromDescription={!id}
                      />
                      <DragDropContext onDragEnd={onTopTenTalentDragEnd}>
                        <Droppable droppableId="top10_droppable">
                          {(drop_provided, snapshot) => (
                            <div
                              className={`course-history-referee-avatars${snapshot.isDraggingOver ? ' is-dragging-over' : ''}`}
                              ref={drop_provided.innerRef}
                              {...drop_provided.droppableProps}
                            >
                              {course_history_topten_talents?.map((item, i) => (
                                <Draggable key={`topten${item.id}`} draggableId={`${item.id}`} index={i}>
                                  {(provided) => (
                                    <div
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      ref={provided.innerRef}
                                      className="course-history-referee-avatar-item"
                                    >
                                      <a
                                        href={`/cms/usertalent/${item.courseparticipant.usertalent.user?.profile?.id}`}
                                        className="course-history-referee-avatar-item__link"
                                      >
                                        <img src={userAvatar(item.courseparticipant.usertalent.user?.profile)} alt="" />
                                      </a>
                                      {show_delete && (
                                        <button
                                          type="button"
                                          className="course-history-referee-avatar-item__delete"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setTopTenMode(1);
                                            _delete(item.id, 'coursehistorytalent');
                                          }}
                                          aria-label="Remove from Top 10"
                                        >
                                          <i className="fa fa-trash" />
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {drop_provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>
              </div>
              )}
              {sectionTab === 'top30' && (
              <div className={`course-history-referees-tab course-history-top30-tab${show_delete ? ' course-history-referees-tab--delete-mode' : ''}`}>
                  <div className="course-history-referee-toolbar clearfix">
                    {isAdmin() && (
                      <button
                        type="button"
                        className="btn btn-cm pull-right ml-10"
                        onClick={() => setTop30CopyEditOpen((o) => !o)}
                        title={top30CopyEditOpen ? 'Hide heading & description editor' : 'Edit heading & description'}
                      >
                        <i className={`fa ${top30CopyEditOpen ? 'fa-times' : 'fa-pencil'}`} />{' '}
                        {top30CopyEditOpen ? '' : ''}
                      </button>
                    )}
                    <a href="#show_delete_top30" onClick={(e) => { e.preventDefault(); setShowDelete(!show_delete) }} className="btn btn-cm pull-right ml-10 "><i className="fa fa-trash"></i></a>
                  </div>

                  <div className="course-history-referee-panel">
                    <div className="course-history-referee-panel__head course-history-referee-panel__head--with-actions">
                      <span className="course-history-referee-panel__title">Top 30</span>
                      <a href="#add_top30_talent" onClick={(e) => {
                        e.preventDefault();
                        var ids = course_history_talents.map(item => item.courseparticipant.id)
                        setExcludeIds(ids)
                        setTopTenMode(0)
                        setCourseParticipantModalIsOpen(true)
                      }} title="Add participant" className="btn btn-cm btn-sm"><i className="fa fa-plus"></i></a>
                    </div>
                    <div className="course-history-referee-panel__body">
                      {top30CopyEditOpen && isAdmin() && (
                        <div className="course-history-top30-form">
                          <NamesWidget
                            languages={languages}
                            names={names}
                            onNamesChange={setNames}
                            showDescription={true}
                            titleField="top30_title"
                            descriptionField="top30_description"
                            stubTitleEntry={stubTop30Title}
                            stubDescriptionEntry={stubTop30Description}
                            allowNewEntryFromDescription={!id}
                          />
                          <p className="course-history-top30-form__save-hint text-muted">
                            Save changes from the <strong>General</strong> tab.
                          </p>
                        </div>
                      )}
                      <DragDropContext onDragEnd={onTalentDragEnd}>
                        <Droppable droppableId="top30_droppable">
                          {(drop_provided, snapshot) => (
                            <div
                              className={`course-history-referee-avatars course-history-referee-avatars--top30${top30CopyEditOpen && isAdmin() ? '' : ' course-history-referee-avatars--solo'}${snapshot.isDraggingOver ? ' is-dragging-over' : ''}`}
                              ref={drop_provided.innerRef}
                              {...drop_provided.droppableProps}
                            >
                              {course_history_talents?.map((item, i) => (
                                <Draggable key={`topthirty${item.id}`} draggableId={`${item.id}`} index={i}>
                                  {(provided) => (
                                    <div
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      ref={provided.innerRef}
                                      className="course-history-referee-avatar-item"
                                    >
                                      <a
                                        href={`/cms/usertalent/${item.courseparticipant.usertalent.user?.profile?.id}`}
                                        className="course-history-referee-avatar-item__link"
                                      >
                                        <img src={userAvatar(item.courseparticipant.usertalent.user?.profile)} alt="" />
                                      </a>
                                      {show_delete && (
                                        <button
                                          type="button"
                                          className="course-history-referee-avatar-item__delete"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setTopTenMode(0);
                                            _delete(item.id, 'coursehistorytalent');
                                          }}
                                          aria-label="Remove from Top 30"
                                        >
                                          <i className="fa fa-trash" />
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {drop_provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>
              </div>
              )}
              {sectionTab === 'episodes' && (
              <div>
                  <div className="clearfix mb-10">
                    <a href="#open" onClick={(e) => {
                      e.preventDefault();
                      setAddHistoryGalleryModalIsOpen(true)
                    }} title="Add New" className="btn btn-cm pull-right ml-10 "><i className="fa fa-plus"></i></a>
                    <a href="#show_delete" onClick={(e) => { e.preventDefault(); setShowDelete(!show_delete) }} className="btn btn-cm pull-right ml-10 "><i className="fa fa-trash"></i></a>
                  </div>
                  <EpisodeGalleryCardsWidget
                    items={courseHistoryGalleries}
                    showDelete={show_delete}
                    onAfterDelete={_getCourseHistoryGalleries}
                  />
              </div>
              )}
              </div>

            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );

}
